<template>

  <v-hover v-slot:default="{ hover }">
    <v-card :class="{'ma-3': true, 'hover': hover}" outlined @click="$emit('edit')">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card-title v-text="room.name"/>
        </v-col>
      </v-row>
    </v-card>
  </v-hover>

</template>


<script>

  export default {
    props: {
      room: {
        type: Object,
        default: () => null
      }
    }
  }

</script>


<style scoped>

  .hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, .05);
  }

</style>